var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"md":"12"}},[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('h2',[_vm._v(" "+_vm._s(_vm.name)+" ")])]),_c('b-col',{staticClass:"text-right",attrs:{"md":"8"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }